import PicabooConstants from '../common/PicabooConstants';
import Black from '../public/images/frameColor/Black.jpg';
import White from '../public/images/frameColor/White.jpg';
import Dark_Ash from '../public/images/frameColor/Dark_Ash.jpg';
import Natural_Ash from '../public/images/frameColor/Natural_Ash.jpg';
import Gallery_Black from '../public/images/frameColor/Gallery_Black.jpg';
import Gallery_White from '../public/images/frameColor/Gallery_White.jpg';
import Gallery_Dark_Ash from '../public/images/frameColor/Gallery_Dark_Ash.jpg';
import Gallery_Natural_Ash from '../public/images/frameColor/Gallery_Natural_Ash.jpg';

export function frameTextureImages() {
  let frameTextureImages = {};

  return frameTextureImages;
}

export function frameGalleryImages() {
  let frameGalleryImages = {};

  return frameGalleryImages;
}
